import { ApiProperty } from "@nestjs/swagger";

export class ApplicationModel{
   
    
    companyName: string;
    moduleName: string[];
    constructor(

companyName: string,
    moduleName: string[],
    ){
        this.companyName = companyName
        this.moduleName = moduleName

    }
   
}